import { action } from "satcheljs";

export const onSingleMailItemSelected: () => {} = action("ON_SINGLE_MAIL_ITEM_SELECT");
